exports.list = {
    path: '/pegawai',
    name: 'pegawai_list', 
      meta: {
        authRequired: true,
      },
    component: () => import("@/views/main/pegawai/List.vue"),
}
exports.show = {
    path: '/pegawai/show/:id',
    name: 'pegawai_show', 
        meta: {
            authRequired: true,
        },
    component: () => import("@/views/main/pegawai/Show.vue"),
}